import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { GENERAL_ROUTES, PERSONALIZATION_ROUTES } from "../../routes";

export const PersonalizationPaddedRoutes: RouteObject[] = [
  // Legacy personalizations list → home (all-experiences table)
  {
    path: PERSONALIZATION_ROUTES.Personalizations,
    element: <Navigate to={GENERAL_ROUTES.Index} replace />,
  },
];
